import { useContext } from "react";
import { MapContainer } from "react-leaflet";

import "leaflet/dist/leaflet.css";

import MarkerMap from "../MarkerMap";
import VectorTileLayer from "../VectorTileLayer";

import "./styles.css";

import { mobileBreakpoint } from "../../styles/breakpoints";

// Em tela estreita o mapa enquadra bem menos área que no desktop. Um nível de
// zoom a menos devolve mais ou menos a mesma vizinhança ao redor do
// empreendimento, e os limites de pan acompanham na mesma proporção.
// Largura zero é uma página ainda oculta (iframe escondido, aba em
// display:none), não um celular: nesse caso fica o zoom de desktop.
const isNarrowScreen = () =>
  typeof window !== "undefined" &&
  window.innerWidth > 0 &&
  window.innerWidth <= mobileBreakpoint;

function MapView({ children, locationsContext, logo, getIcon }) {
  const {
    locations,
    categories,
    center,
    mapConfig,
    discount,
    titlePage,
    locationsConfig,
  } = useContext(locationsContext);
  const empreendimento = center;
  const mapCenter = center.latlng;

  const zoomOffset = isNarrowScreen() ? 1 : 0;
  const limit = center.limit * (zoomOffset ? 1.6 : 1);
  const limits = [
    [mapCenter[0] + limit, mapCenter[1] + limit],
    [mapCenter[0] - limit, mapCenter[1] - limit],
  ];

  document.title = titlePage;

  return (
    <>
      <MapContainer
        className="map-view-container"
        center={mapCenter}
        minZoom={
          center.minZoom != null ? center.minZoom - zoomOffset : center.minZoom
        }
        maxBoundsViscosity={0.8}
        zoom={center.zoom - zoomOffset}
        style={{
          backgroundColor: mapConfig.backgroundColor,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        maxBounds={limits}
        attributionControl={true}
      >
        <VectorTileLayer />
        {locations.map(
          (item, index) =>
            categories[item.id].active && (
              <MarkerMap
                key={index}
                location={item}
                icon={getIcon[categories[item.id].icon]}
                zIndexOffset={-1}
                discount={discount}
                tooltipDirection={item?.tooltipDirection}
                tooltipStyle={item?.tooltipStyle}
              />
            )
        )}
        {locationsConfig?.resetPoints.map((point, index) => (
          <MarkerMap
            key={`${index}_${point.point}`}
            location={point}
            icon={logo}
            zIndexOffset={1000}
            classNameTooltip="z-index-1000"
            discount={discount}
            tooltipDirection={point?.tooltipDirection}
            // accentColor={center.accentColor}
            tooltipStyle={point?.tooltipStyle}
          />
        ))}
        {!locationsConfig?.resetPoints && (
          <MarkerMap
            location={empreendimento}
            icon={logo}
            zIndexOffset={1000}
            classNameTooltip="z-index-1000"
            discount={discount}
            tooltipDirection={empreendimento?.tooltipDirection}
            // accentColor={center.accentColor}
            tooltipStyle={empreendimento?.tooltipStyle}
          />
        )}
        {children}
      </MapContainer>
    </>
  );
}

export default MapView;
